'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["centerContent", "children", "className", "contextual", "onClick", "style", "tabIndex", "use", "width", "Inner"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import memoizeOne from 'react-utils/memoizeOne';
import UIClickable from '../button/UIClickable';
import { hidden } from '../utils/propTypes/decorators';
import { SandboxContext } from '../context/SandboxContext';
import { jsx as _jsx } from "react/jsx-runtime";
const getStyle = (style, centerContent, width) => centerContent ? Object.assign({}, style, {
  maxWidth: width
}) : style;
const USE_CLASSES = {
  dark: '',
  light: 'private-overlay--light'
};
class UIOverlay extends Component {
  constructor(props) {
    super(props);
    this.handleClick = evt => {
      const {
        onClick
      } = this.props;
      if (onClick) onClick(evt);
    };
    this._getStyle = memoizeOne(getStyle);
  }
  render() {
    const _this$props = this.props,
      {
        centerContent,
        children,
        className,
        contextual,
        onClick,
        style,
        tabIndex,
        use,
        width,
        Inner
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const isSandboxed = contextual || this.context.sandboxed;
    const computedClassName = classNames("private-overlay uiOverlay-backdrop", className, USE_CLASSES[use], isSandboxed && 'private-overlay--contextual');
    const computedChildrenWrapperClassName = centerContent ? 'private-modal__container' : "";
    const isClickable = onClick;
    const Overlay = isClickable ? UIClickable : 'div';
    const overlayProps = isClickable ? {
      cursor: 'auto'
    } : undefined;
    return /*#__PURE__*/_jsx(Overlay, Object.assign({}, rest, overlayProps, {
      className: computedClassName,
      onClick: this.handleClick,
      role: "presentation",
      tabIndex: isSandboxed ? null : tabIndex,
      children: /*#__PURE__*/_jsx(Inner, {
        className: computedChildrenWrapperClassName,
        ref: ref => {
          this._innerEl = ref;
        },
        style: this._getStyle(style, centerContent, width),
        children: children
      })
    }));
  }
}
UIOverlay.displayName = 'UIOverlay';
UIOverlay.contextType = SandboxContext;
UIOverlay.defaultProps = {
  centerContent: true,
  contextual: false,
  use: 'dark',
  Inner: 'div'
};
UIOverlay.propTypes = {
  centerContent: PropTypes.bool.isRequired,
  children: PropTypes.node,
  contextual: PropTypes.bool.isRequired,
  use: PropTypes.oneOf(Object.keys(USE_CLASSES)),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  Inner: hidden(PropTypes.elementType)
};
export default UIOverlay;